var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8ECC7F44-42D3-478D-9070-4016405D3263") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High-Fi-Dashboard-T2P",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Widgets---T2P-Agencias",
    transform: "translate(-255.000000, -875.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar---\\xDAltimo-TurnoOPC2",
    transform: "translate(56.000000, 860.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HASTA/Calendario",
    transform: "translate(19.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.157352,20.3402373 C185.98871,20.4568127 185.949455,20.6838844 186.069673,20.8474161 C186.189892,21.0109478 186.42406,21.0490134 186.592703,20.932438 L191.842677,17.3033516 C192.052198,17.1585185 192.052492,16.8567658 191.843253,16.7115496 L186.593278,13.0679601 C186.424863,12.9510764 186.190621,12.9887136 186.070085,13.1520251 C185.949548,13.3153366 185.988361,13.5424797 186.156777,13.6593634 L190.97983,17.0066612 L186.157352,20.3402373 Z M188.5,26 C193.746705,26 198,21.7467051 198,16.5 C198,11.2532949 193.746705,7 188.5,7 C183.253295,7 179,11.2532949 179,16.5 C179,21.7467051 183.253295,26 188.5,26 Z M188.5,27 C182.70101,27 178,22.2989899 178,16.5 C178,10.7010101 182.70101,6 188.5,6 C194.29899,6 199,10.7010101 199,16.5 C199,22.2989899 194.29899,27 188.5,27 Z",
    id: "iconspace_Next_25px"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.ddb6cb80ce466800b7a963e93fe8e533.svg";
export { ForwardRef as ReactComponent };